import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Crest } from "./bits";

const IMG = "/brand/hostel-family.jpg";

export const GoogleButton = () => {
  const go = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button type="button" onClick={go} data-testid="google-login-button"
      className="w-full h-11 rounded-full border border-stone-300 bg-white hover:bg-stone-50 font-semibold text-stone-800 flex items-center justify-center gap-3 transition-colors">
      <svg className="h-5 w-5" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>
      Continue with Google
    </button>
  );
};

export default function AuthLayout({ title, subtitle, children, footer }) {
  const { settings } = useAuth();
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative grain">
        <img src={IMG} alt="Hostel brothers" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-stone-950/95 via-stone-900/50 to-stone-900/20" />
        <div className="absolute bottom-0 p-12">
          <p className="eyebrow !text-amber-400">{settings.hostel_name} • {settings.institution}</p>
          <p className="font-display text-4xl font-bold text-white mt-3 max-w-md leading-tight">{settings.tagline}</p>
        </div>
      </div>
      <div className="flex flex-col justify-center px-6 sm:px-12 lg:px-20 py-12">
        <Link to="/" data-testid="auth-home-link" className="font-display font-bold text-lg text-stone-900 mb-12 flex items-center gap-3"><Crest />{settings.hostel_name}</Link>
        <div className="max-w-md w-full fade-up">
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-stone-900">{title}</h1>
          <p className="mt-3 text-stone-600">{subtitle}</p>
          <div className="mt-10 space-y-5">{children}</div>
          <div className="mt-8 text-sm text-stone-600">{footer}</div>
        </div>
      </div>
    </div>
  );
}
